"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Convierte un objeto a un arbol que se puede visualizar con el tree view */
function valueToJsonTreeView(obj) {
    function jsonTreeToView(tree) {
        const { key, value, children } = tree;
        return { key, value, children: children.map(jsonTreeToView) };
    }
    return jsonTreeToView(valueToJsonTree(obj));
}
exports.valueToJsonTreeView = valueToJsonTreeView;
function valueToJsonTree(value) {
    const jvalue = valueToJsonValue(value);
    const children = (() => {
        switch (jvalue.tree) {
            case "leaf":
                return [];
            case "object": {
                return Object.keys(value).map(key => (Object.assign({}, valueToJsonTree(value[key]), { key: key })));
            }
            case "array": {
                const arr = value;
                const ret = [];
                for (let i = 0; i < arr.length; i++) {
                    ret.push(Object.assign({}, valueToJsonTree(arr[i]), { key: i }));
                }
                return ret;
            }
        }
    })();
    return {
        value: jvalue,
        children,
        key: ""
    };
}
function valueToJsonValue(value) {
    if (value == null) {
        return { value: null, type: "null", tree: "leaf", count: 0 };
    }
    ;
    if (typeof value == "number" || typeof value == "string" || typeof value == "boolean") {
        return {
            value: value,
            type: typeof value,
            tree: "leaf",
            count: 0
        };
    }
    else if (typeof value == "function") {
        return { value: null, type: "function", tree: "leaf", count: 0 };
    }
    else if (isArray(value)) {
        return { value: null, type: "array", tree: "array", count: value.length };
    }
    else {
        const keys = Object.keys(value);
        return { value: null, type: "object", tree: "object", count: keys.length };
    }
}
function isArray(obj) {
    const arr = obj;
    return arr.length != null;
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/jsonview/logic.js
// module id = 2237
// module chunks = 0